export default __webpack_public_path__ + "img/img_tej-38fbbb958af8040d37e25deb9fb6fb44.jpg";